// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9ac9eeca","952":"319327fe"}[chunkId] + ".chunk.js";
};